import { Checkbox, Fieldset, Switch, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { messagingChannelsConfig } from 'src/Components/Forms/Contact/PhysicalContactForm/messagingChannelsConfig';
import { ContactKind, CreateMessagingChannelDtoTypeEnum } from 'src/Services/API/generated';

import AddressAutocomplete from '../../../../Shared/AddressAutocomplete/AddressAutocomplete.component';

import styles from './ContactSectionForm.module.scss';
import { Props } from './ContactSectionForm.types';

const COMPANY_HIDDEN_CHANNELS: string[] = [
  CreateMessagingChannelDtoTypeEnum.Signal,
  CreateMessagingChannelDtoTypeEnum.Messenger,
];

const ContactSectionForm = ({ form, initialAddressText, addressPrefill }: Props) => {
  // t('contacts.SMS', 'SMS')
  // t('contacts.Email', 'Email')
  // t('contacts.Signal', 'Signal')
  // t('contacts.WhatsApp', 'WhatsApp')
  // t('contacts.Messenger', 'Messenger')

  const { t } = useTranslation();
  const isCompany = form.values.kind === ContactKind.Company;
  // A company only gets the channels it actually uses; values already saved stay stored.
  const channels = isCompany
    ? messagingChannelsConfig.filter(({ type }) => !COMPANY_HIDDEN_CHANNELS.includes(type))
    : messagingChannelsConfig;

  return (
    <Fieldset legend={t('contacts.contact', 'Contact')}>
      <div className={styles.content}>
        <TextInput placeholder={t('contacts.email', 'Email')} {...form.getInputProps('email')} />
        <div className={styles.phoneContent}>
          <TextInput
            placeholder={t('contacts.phone', 'Téléphone')}
            {...form.getInputProps('phoneNumber')}
          />
          <Switch
            checked={form.values.isEmergencyContact}
            label={t('contacts.emergencyContact', "Définir comme contact d'urgence")}
            {...form.getInputProps('isEmergencyContact')}
          />
        </div>
        <AddressAutocomplete
          {...form.getInputProps('placeId')}
          placeholder={
            isCompany
              ? t('contacts.company.address', "Entrez l'adresse de l'entreprise")
              : t('contacts.address', "Entrez l'adresse du contact")
          }
          description={t('contacts.addressDescription', 'Adresse')}
          initialAddressText={initialAddressText}
          prefill={addressPrefill}
        />
        <p className={styles.preferredChannel}>
          {t('contacts.preferredMessagingChannels', 'Canaux de messagerie préférés')}
        </p>
        <div className={styles.checkboxGroup}>
          {channels.map(({ type, icon: Icon, color, label }) => {
            const isChecked = form.values.messagingChannels[type];
            const showInput = type === CreateMessagingChannelDtoTypeEnum.Messenger && isChecked;
            return (
              <div className={styles.checkBoxCard} key={type}>
                <Checkbox
                  checked={isChecked}
                  onChange={event =>
                    form.setFieldValue(`messagingChannels.${type}`, event.currentTarget.checked)
                  }
                />
                <Icon color={color} size={28} />
                <span>{t(`contacts.${label}`, label)}</span>
                {showInput && (
                  <TextInput
                    size="xs"
                    placeholder="Profil"
                    {...form.getInputProps('messengerValue')}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </Fieldset>
  );
};

export default ContactSectionForm;
